module.exports = __webpack_public_path__ + "static/media/special_0.88f6452b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_0.csv
// module id = 736
// module chunks = 0